import { createGlobalStyle } from "styled-components";

export const Styles = createGlobalStyle`
  :root {
    --font-display: 'Spectral', Georgia, 'Times New Roman', serif;
    --font-body: 'IBM Plex Sans', system-ui, -apple-system, 'Segoe UI', sans-serif;

    /* Tinta: el petróleo del logotipo */
    --ink: #0F2A3A;
    --ink-2: #163A4E;
    --ink-deep: #0B2130;
    --on-ink: #E9EFEC;
    --on-ink-muted: #A9BCB6;

    /* Papel y hoja de libro mayor */
    --paper: #F3F5F2;
    --sheet: #FBFCFA;
    --rule: #CBD5CF;
    --rule-soft: #E1E7E3;

    /* Verde libro mayor: único acento */
    --ledger: #3D6B5B;
    --ledger-ink: #2C5446;
    --ledger-soft: #DCE6E0;
    --ledger-on-ink: #8FB8A6;

    --text: #172A33;
    --text-muted: #4E6068;

    --radius: 3px;
    --gutter: clamp(1rem, 4vw, 3rem);
    --section-y: clamp(4.5rem, 9vw, 8rem);

    /* Compatibilidad con estilos previos */
    --color-primary: var(--ink);
    --color-text: var(--text);
    --color-text-muted: var(--text-muted);
  }

  *, *::before, *::after { box-sizing: border-box; }

  html { scroll-behavior: smooth; scroll-padding-top: 88px; }

  body, html, a, button, input, textarea {
    font-family: var(--font-body);
  }

  body {
    margin: 0;
    padding: 0;
    background: var(--paper);
    color: var(--text);
    overflow-x: hidden;
    font-feature-settings: "tnum" 1;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  a {
    color: var(--ledger-ink);
    text-decoration: none;
    &:hover { color: var(--ink); }
  }

  input, textarea {
    width: 100%;
    font-size: 1rem;
    color: var(--text);
    outline: none;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: var(--font-display);
    color: var(--ink);
    font-weight: 400;
    line-height: 1.15;
    letter-spacing: -0.01em;
    text-wrap: balance;
    margin: 0;
  }

  h2 {
    font-size: clamp(2rem, 1.4rem + 2.4vw, 3.25rem);
    font-weight: 300;
  }

  h3 {
    font-size: 1.375rem;
  }

  p {
    color: var(--text-muted);
    font-size: 1.0625rem;
    line-height: 1.7;
    margin: 0;
  }

  ::selection { background: var(--ledger-soft); color: var(--ink); }

  *:focus-visible {
    outline: 2px solid var(--ledger);
    outline-offset: 3px;
  }
  *:focus:not(:focus-visible) { outline: none; }

  .ant-drawer-content { background: var(--paper); }
  .ant-drawer-body {
    display: flex;
    flex-direction: column;
    text-align: left;
    padding: 1.5rem;
  }
  .ant-drawer-content-wrapper { width: 300px !important; }

  @media (prefers-reduced-motion: reduce) {
    html { scroll-behavior: auto; }
    *, *::before, *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
    }
  }
`;
